import $ from 'jquery';
import Highcharts from '@/lib/highcharts_with_modules';

export default function compToPriorFiscalYearGraph (data) {
  // To set the dataLabels
  var lastYearArr = data.lastYear.data;

  Highcharts.chart("fytdGraph", {
    chart: {
      type: "column"
    },
    title: {
      text: "Comparison to Prior Fiscal Year"
    },
    xAxis: {
      categories: ["Petroleum", "Alt Fuel", "Missed Opps"]
    },
    yAxis: {
      title: {
        text: "GGE"
      }
    },
    tooltip: {
      useHTML: true,
      formatter: function() {
        return "<b>"+ this.x + ": </b> "+ Math.round(this.y).toLocaleString() +" GGE";
      }
    },
    plotOptions: {
      column: {
        // allowPointSelect: true,
        cursor: "pointer",
        showInLegend: true,
        dataLabels: {
          enabled: true,
          useHTML: true,
          formatter: function () {
            var lastYear = lastYearArr[this.point.x],
            y = this.y,
            val;

            // the reduce makes sure that there's actually a comparison worth doing
            if (data.lastYear.data.reduce(function(a,b){return a+b;}) <= 1000) {
              $("#no-prior-comparison").html("Prior year data is incomplete.");
            } else if (lastYear !== y && data.lastYear.data.reduce(function(a,b){return a+b;}) !== 0) {
              val = Math.round((((y-lastYear)/lastYear)*100));
              switch (this.point.x) {
                case 0:
                  if (val > 0) {
                    return "<span style='color:red'>+" + val + "%</span>";
                  } else {
                    return "<span style='color:green'>" + val + "%</span>";
                  }
                case 1:
                  if (val < 0) {
                    return "<span style='color:red'>" + val + "%</span>";
                  } else {
                    return "<span style='color:green'>+" + val + "%</span>";
                  }
                case 2:
                  if (val > 0) {
                    return "<span style='color:red'>+" + val + "%</span>";
                  } else {
                    return "<span style='color:green'>" + val + "%</span>";
                  }
              }
            }
          }
        }
      }
    },
    series: [
      {
        name: 'FY ' + data.lastYear.name,
        data: data.lastYear.data,
        color: "#C3C8C8"
      },
      {
        name: 'FY ' + data.thisYear.name,
        data: data.thisYear.data,
        color: "#5E6A71"
      }
    ],
    legend: {
      enabled: true,
      align: "right",
      verticalAlign: "middle",
      layout: "vertical"
    },
    credits: {
      enabled: true
    },
    exporting: {
      enabled: true,
      buttons: {
        contextButton: {
          menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'separator', 'downloadCSV', 'downloadXLS']
        }
      },
    }
  });
}
